/* PLTÉ Maison · Early access (20 okt 2026, lancering 26 okt). Laadt alleen zolang de schakelaar aan staat (plte-foot-hooks, na plte-app.js).
   1. Aanmelden [data-ea-form]: het adres gaat naar Shopify's klantformulier (tags + toestemming); Klaviyo krijgt het van Shopify.
      Zonder data-ea-native post het formulier op de achtergrond (antwoord via /cart?view=ea-ok)
      en verschijnt [data-ea-done] op dezelfde plek. Vraagt Shopify een controle (hCaptcha) of valt het netwerk weg, dan gaat het
      formulier alsnog gewoon door. Deze browser onthoudt een geslaagde aanmelding per campagne (localStorage): geen uitnodiging
      meer, en het formulier toont meteen "je staat op de lijst".
   2. Aftelklokken [data-lclock]: per seconde bij; op nul weg en de pagina één keer opnieuw (de poort schakelt mee). Een pagina die
      vóór een omslagmoment is gemaakt maar erna wordt bekeken (cache), laadt ook één keer opnieuw.
   3. Uitnodiging [data-ea-invite]: na data-delay seconden op de site (opgeteld over pagina's), één keer per sessie; nooit na sluiten
      of aanmelden, nooit voor bekende Klaviyo-profielen (klik uit een mail of eerder formulier), nooit boven een open tas of menu.
   4. Tas: regels met een product achter de poort krijgen uitleg en de afrekenknop gaat dicht zolang de poort voor deze bezoeker dicht is. */
(function () {
  'use strict';
  var P = window.PLTE = window.PLTE || {}, E = P.ea;
  if (!E) return;
  var html = document.documentElement, S = E.strings || {}, K = 'plte-ea:' + (E.key || 'x') + ':';
  function mem(k, v) { try { if (v === undefined) return localStorage.getItem(K + k); localStorage.setItem(K + k, v); } catch (e) { return null; } }
  function ses(k, v) { try { if (v === undefined) return sessionStorage.getItem(K + k); sessionStorage.setItem(K + k, v); } catch (e) { return null; } }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* 1. aanmelden */
  /* Klaviyo krijgt het adres alleen via Shopify (klantformulier → webhook: toestemming, lijst, tag early-access). Deze pagina roept
     Klaviyo zelf niet aan, ook geen identify: Klaviyo's botbeveiliging onderdrukte aanmelders na een eigen client-aanroep (eatest5,
     eatest9) én na alleen identify (eatest10), en de webhook heft dat niet op: geen enkele mail (26 okt). */
  function doneFor(f) { return f && f.id ? document.querySelector('[data-ea-done="' + f.id + '"]') : null; }
  function showDone(f, quiet) {
    var d = doneFor(f); if (!d) return;
    f.hidden = true; d.hidden = false;
    if (!quiet) { try { d.focus({ preventScroll: true }); } catch (e) {} if (P.burstFrom) P.burstFrom(d, { count: 7, mode: 'ring' }); }
  }
  function showErr(f) {
    var e = f.querySelector('.list-form__err');
    if (!e) { e = document.createElement('p'); e.className = 'list-form__err'; e.setAttribute('role', 'alert'); f.appendChild(e); }
    e.textContent = S.err || '';
  }
  /* Shopify beschermt het klantformulier met hCaptcha (captcha-bootstrap + ce_storefront_forms_captcha_hcaptcha): bij de eerste
     focus bindt het script het formulier, bewaart de submit-functie die het formulier dán heeft, en roept die na het token aan.
     Daarom krijgt elk EA-formulier vooraf een eigen submit: Shopify haalt het token, wij posten (met token en form_key) op de
     achtergrond naar /contact met return_to /cart?view=ea-ok en lezen EA:OK / EA:ERR. Een frame kan niet: Shopify stuurt
     x-frame-options DENY. Lukt de post niet, dan een foutregel en opnieuw proberen geeft een nieuw token. */
  function settle(f) { clearTimeout(f.__eaT); f.removeAttribute('aria-busy'); }
  function joined(f) {
    mem('joined', '1'); showDone(f);
    try { document.dispatchEvent(new CustomEvent('plte:ea-joined', { detail: { source: f.getAttribute('data-ea-src') } })); } catch (e) {}
  }
  function post(f) {
    if (!window.fetch || !window.FormData) { HTMLFormElement.prototype.submit.call(f); return; }
    var fd = new FormData(f);
    fd.set('return_to', '/cart?view=ea-ok&t=' + Date.now());
    f.setAttribute('aria-busy', 'true'); clearTimeout(f.__eaT);
    fetch((f.getAttribute('action') || '/contact').split('#')[0], { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) { return r.text().then(function (t) { return { ok: r.ok, t: t }; }); })
      .then(function (r) {
        settle(f);
        if (r.t.indexOf('EA:OK') > -1 || r.t.indexOf('EA:NONE') > -1) joined(f);
        else showErr(f);
      })
      .catch(function () { settle(f); showErr(f); });
  }
  $$('[data-ea-form]').forEach(function (f) {
    if (f.hasAttribute('data-ea-native') || !doneFor(f)) return;
    try { f.submit = function () { post(f); }; } catch (e) {}
  });
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.hasAttribute || !f.hasAttribute('data-ea-form')) return;
    var inp = f.querySelector('input[type="email"]'), email = inp ? inp.value.trim() : '';
    if (!email) return;
    /* onthouden pas na een geslaagde post (EA:OK, terugkeer met #formulier of de bedankpagina), nooit al bij de klik: wie op een
       hCaptcha-puzzel strandt, zou anders bij een volgend bezoek "je staat op de lijst" zien zonder erop te staan */
    if (f.hasAttribute('data-ea-native') || P.preview || !doneFor(f)) return;
    var e = f.querySelector('.list-form__err'); if (e) e.textContent = '';
    if (!f.dataset.hcaptchaBound && !f.dataset.recaptchaBound && !document.getElementById('captcha-bootstrap')) { ev.preventDefault(); post(f); return; }
    /* Shopify's script handelt de klik af (token, daarna onze post). Nog niet gebonden: Shopify slikt deze klik in; zodra het
       formulier gebonden is, verzenden we alsnog één keer (geen tweede klik nodig). */
    var bound = f.dataset.hcaptchaBound || f.dataset.recaptchaBound;
    f.setAttribute('aria-busy', 'true'); clearTimeout(f.__eaT);
    f.__eaT = setTimeout(function () { settle(f); }, bound ? 20000 : 6000);
    if (!bound && window.MutationObserver && !f.__eaMo) {
      f.__eaMo = new MutationObserver(function () {
        if (!f.dataset.hcaptchaBound && !f.dataset.recaptchaBound) return;
        f.__eaMo.disconnect(); f.__eaMo = null;
        if (f.getAttribute('aria-busy') === 'true') f.submit();
      });
      f.__eaMo.observe(f, { attributes: true, attributeFilter: ['data-hcaptcha-bound', 'data-recaptcha-bound'] });
    }
  }, true);
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest('[data-ea-again]'), r = ev.target.closest('[data-ea-reload]'), fo = ev.target.closest('[data-ea-focus]');
    if (r) { location.reload(); return; }
    if (fo) { var i = document.getElementById(fo.getAttribute('data-ea-focus')); if (i && !i.closest('[hidden]')) { ev.preventDefault(); i.scrollIntoView({ block: 'center', behavior: 'smooth' }); setTimeout(function () { try { i.focus({ preventScroll: true }); } catch (e) {} }, 450); } return; }
    if (!a) return;
    var d = a.closest('[data-ea-done]'), f = d && document.getElementById(d.getAttribute('data-ea-done'));
    if (!f) return;
    d.hidden = true; f.hidden = false;
    var inp = f.querySelector('input[type="email"]'); if (inp) { inp.value = ''; try { inp.focus(); } catch (e) {} }
  });
  /* terug na een gewone post (vangnet) of op de bedankpagina: onthouden; wie al op de lijst staat ziet meteen de bevestiging */
  $$('[data-list-ok]').forEach(function (ok) { var f = ok.closest('[data-ea-form]'); if (f && location.hash === '#' + f.id) mem('joined', '1'); });
  if (document.querySelector('[data-ea-thanks]')) mem('joined', '1');
  /* tijdens live niet: wie zich vóór de start aanmeldde moet daar de inlogknop zien, niet de lanceringstekst (29 okt) */
  if (mem('joined') && !E.eligible && !E.customer && E.phase !== 'live') $$('[data-ea-form]').forEach(function (f) { if (doneFor(f)) showDone(f, true); });

  /* 2. aftelklokken en omslagmomenten */
  function again(t) {
    if (ses('r' + t)) return; ses('r' + t, '1');
    setTimeout(function () {
      var u = location.href.split('#'), base = u[0].replace(/([?&])ea=\d+(&|$)/, '$1').replace(/[?&]$/, '');
      location.replace(base + (base.indexOf('?') > -1 ? '&' : '?') + 'ea=' + t + (u[1] ? '#' + u[1] : ''));
    }, 300 + Math.random() * 1500);
  }
  var nowS = Date.now() / 1000;
  if (E.phase === 'pre' && E.start && nowS >= E.start) again(E.start);
  else if (E.phase !== 'ended' && E.end && nowS >= E.end) again(E.end);
  var clocks = $$('[data-lclock]').map(function (el) {
    var c = { el: el, t: +el.getAttribute('data-lclock'), r: el.hasAttribute('data-lclock-reload'), n: {} };
    $$('[data-u]', el).forEach(function (u) { c.n[u.getAttribute('data-u')] = u; });
    return c;
  });
  function two(v) { return v < 10 ? '0' + v : '' + v; }
  function put(el, v) { if (el) { v = two(v); if (el.textContent !== v) el.textContent = v; } }
  function paint() {
    var now = Date.now() / 1000;
    clocks.forEach(function (c) {
      if (c.gone) return;
      var left = Math.floor(c.t - now);
      if (left <= 0) { c.gone = true; c.el.hidden = true; if (c.r) again(c.t); return; }
      put(c.n.d, Math.floor(left / 86400)); put(c.n.h, Math.floor(left % 86400 / 3600)); put(c.n.m, Math.floor(left % 3600 / 60)); put(c.n.s, left % 60);
    });
  }
  function tick() { if (!document.hidden) paint(); setTimeout(tick, 1000 - Date.now() % 1000 + 10); }
  if (clocks.length) { paint(); tick(); document.addEventListener('visibilitychange', paint); }

  /* 3. uitnodiging */
  var inv = document.querySelector('[data-ea-invite]'), opened = false, last = null;
  if (/[?&](_kx|_ke)=|utm_source=klaviyo/i.test(location.search)) mem('known', '1');
  function quiet() { return E.eligible || mem('joined') || mem('closed') || mem('known'); }
  function busy() {
    var a = document.activeElement;
    return html.classList.contains('is-locked') || html.classList.contains('threshold-active') || (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName));
  }
  function trap(ev) {
    if (ev.key === 'Escape') { close(); return; }
    if (ev.key !== 'Tab') return;
    var f = $$('a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled])', inv).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === a) { ev.preventDefault(); z.focus(); }
    else if (!ev.shiftKey && document.activeElement === z) { ev.preventDefault(); a.focus(); }
  }
  function open() {
    if (opened || quiet()) return;
    opened = true; ses('shown', '1'); last = document.activeElement;
    inv.hidden = false; html.classList.add('is-locked'); if (P.lenis) P.lenis.stop();
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      inv.classList.add('is-open');
      var c = inv.querySelector('[role="dialog"]'); try { c.focus({ preventScroll: true }); } catch (e) {}
    }); });
    document.addEventListener('keydown', trap);
  }
  function close() {
    if (!opened) return;
    opened = false; mem('closed', '1');
    inv.classList.remove('is-open');
    html.classList.remove('is-locked'); if (P.lenis) P.lenis.start();
    document.removeEventListener('keydown', trap);
    setTimeout(function () { inv.hidden = true; }, 520);
    if (last && last.focus) { try { last.focus({ preventScroll: true }); } catch (e) {} }
  }
  if (inv) {
    inv.addEventListener('click', function (ev) { if (ev.target.closest('[data-ea-invite-close]')) close(); });
    if (!quiet() && !ses('shown')) {
      var t0 = +(ses('t0') || 0); if (!t0) { t0 = Date.now(); ses('t0', String(t0)); }
      var wait = Math.max(3000, (+inv.getAttribute('data-delay') || 20) * 1000 - (Date.now() - t0));
      setTimeout(function attempt() {
        if (quiet()) return;
        if (busy()) { setTimeout(attempt, 3000); return; }
        var k = window.klaviyo, settled = false;
        function go(known) { if (settled) return; settled = true; if (known) mem('known', '1'); else open(); }
        if (k && typeof k.isIdentified === 'function') {
          try { k.isIdentified().then(function (id) { go(!!id); }, function () { go(false); }); } catch (e) { go(false); }
          setTimeout(function () { go(false); }, 1500);
        } else go(false);
      }, wait);
    }
  }

  /* 4. tas: uitleg per regel en de afrekenknop dicht zolang de poort voor deze bezoeker dicht is */
  function mark() {
    var hit = false;
    if (E.gate === 'locked' && E.locked && E.locked.length) {
      $$('[data-line]').forEach(function (li) {
        if (!li.getAttribute('data-key')) return;
        var a = li.querySelector('.line__media'), href = (a && a.getAttribute('href')) || '';
        var handle = href.split('?')[0].split('#')[0].replace(/\/+$/, '').split('/').pop();
        if (E.locked.indexOf(handle) < 0) return;
        hit = true;
        var err = li.querySelector('[data-line-error]');
        if (err && err.hidden && S.lineLocked) { err.textContent = S.lineLocked; err.hidden = false; }
      });
    }
    $$('[data-checkout]').forEach(function (b) {
      b.classList.toggle('is-ea-locked', hit);
      if (hit) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-checkout].is-ea-locked');
    if (b) { ev.preventDefault(); ev.stopPropagation(); if (P.toast) P.toast(S.checkoutLocked); }
  }, true);
  document.addEventListener('submit', function (ev) {
    var b = ev.submitter;
    if (b && b.classList && b.classList.contains('is-ea-locked')) { ev.preventDefault(); if (P.toast) P.toast(S.checkoutLocked); }
  }, true);
  function hook() {
    if (P.cart && P.cart.on) { P.cart.on(function () { setTimeout(mark, 0); }); mark(); return true; }
    return false;
  }
  if (!hook()) document.addEventListener('plte:ready', function () { if (!hook()) mark(); });
})();
